export enum InterestsStepName {
  Explain = 'explain',
  ChooseTag = 'chooseTag',
  ChooseListing = 'chooseListing',
}
